export default __webpack_public_path__ + "static/media/printing_queue.01126185.png";